export default {"src":"/_next/static/media/LexisNexis.ba9c0f5e.svg","height":239,"width":1024};